export enum ErrorTranslationKey {
  ErrorLoaderData = 'error_loader_data',
  ErrorForbidden = 'error_forbidden',
}
